/* eslint-disable no-restricted-imports */
import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import * as actions from "../../../_redux/schCourseWorkInfos/schCourseWorkInfosActions";
import { useSchCourseWorkInfosUIContext } from "../SchCourseWorkInfosUIContext";

export function SchCourseWorkInfoDeleteDialog({ id, show, onHide }) {
  // SchCourseWorkInfos UI Context
  const schCourseWorkInfosUIContext = useSchCourseWorkInfosUIContext();
  const schCourseWorkInfosUIProps = useMemo(() => {
    return {
      setIds: schCourseWorkInfosUIContext.setIds,
      queryParams: schCourseWorkInfosUIContext.queryParams,
    };
  }, [schCourseWorkInfosUIContext]);

  // SchCourseWorkInfos Redux state
  const dispatch = useDispatch();
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.schCourseWorkInfos.actionsLoading }),
    shallowEqual
  );

  // if !id we should close modal
  useEffect(() => {
    if (!id) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // looking for loading/dispatch
  useEffect(() => {}, [isLoading, dispatch]);

  const deleteSchCourseWorkInfo = () => {
    // server request for deleting schCourseWorkInfo by id
    dispatch(actions.deleteSchCourseWorkInfo(id)).then(() => {
      // refresh list after deletion
      dispatch(actions.fetchSchCourseWorkInfos(schCourseWorkInfosUIProps.queryParams));
      // clear selections list
      schCourseWorkInfosUIProps.setIds([]);
      // closing delete modal
      onHide();
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {isLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          SchCourseWorkInfo Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>Are you sure to permanently delete this schCourseWorkInfo?</span>
        )}
        {isLoading && <span>SchCourseWorkInfo is deleting...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={deleteSchCourseWorkInfo}
            className="btn btn-delete btn-elevate"
          >
            Delete
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
